import { all, call, put, takeLatest } from 'redux-saga/effects'
import * as actions from './actions'
import * as api from './api'
import { message } from 'antd'

function* fetchGptPromptsWorker() {
  try {
    const { data } = yield call(api.getGptPrompts)
    const formattedData = data.data.map((item) => ({
      id: item.id,
      ...item.attributes,
    }))
    yield put(actions.fetchGptPromptsSuccess(formattedData))
  } catch (e) {
    yield put(actions.fetchGptPromptsFailure(e))
  }
}

function* updateGptPromptWorker({ payload, promise }) {
  try {
    const { id, values, callback } = payload
    const { data } = yield call(api.updateGptPrompt, {
      id,
      data: {
        prompt: values.prompt,
        developer_hint: values.developer_hint,
        model: values.model,
        temperature: values.temperature,
        max_output_tokens: values.max_output_tokens,
      },
    })

    const formattedData = {
      id: data.data.id,
      ...data.data.attributes,
    }

    yield put(actions.updateGptPromptSuccess(formattedData))
    message.success('GPT prompt updated successfully')

    if (callback) {
      callback()
    }

    if (promise) {
      yield call(promise.resolve)
    }
  } catch (error) {
    console.error(error)
    if (promise) {
      yield call(promise.resolve, error?.response?.data)
    }
  }
}

export default function* () {
  yield all([
    takeLatest(actions.fetchGptPromptsRequest, fetchGptPromptsWorker),
    takeLatest(actions.updateGptPromptRequest, updateGptPromptWorker),
  ])
}
